module.exports = __webpack_public_path__ + "media/components/style/icon-lock@2x-72c3fad683922a2b5df0fad17ab46d99.png";